import type * as ents from '@attain-apps/entities'

/**
 * State for the duplicate detection plugin
 */
export interface State {
  /** Employees matching the current name and job title being entered */
  duplicates: readonly ents.extra.space.Employee[]
  /** Whether a duplicate check is currently in progress */
  isChecking: boolean
}

export namespace State {
  export const INITIAL: Readonly<State> = {
    duplicates: [],
    isChecking: false,
  }
}
